import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/$wsSlug/projects')({
  component: ProjectsLayout,
});

/**
 * Layout para la seccion de proyectos del workspace.
 * Renderiza <Outlet /> para que las rutas hijas (listado, board, list, etc.)
 * se monten correctamente en el arbol de rutas.
 * El listado real vive en projects.index.tsx.
 */
function ProjectsLayout() {
  return <Outlet />;
}
